export class SensitivityAnnotationsCondition {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "sensitivityAnnotations",
            "baseName": "sensitivityAnnotations",
            "type": "Array<SensitivityLevel>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SensitivityAnnotationsCondition.attributeTypeMap;
    }
    constructor() {
    }
}
